import Cookies from 'js-cookie';
import MIS from '../../utils/mis';
import { logout } from '../../api/login';
import { gioClearUserId } from '@/utils/gio.js'
const user = {
    state: {
      userDetail:{},
      technical: false,
    },
    mutations: {
        setUserDetail(state, userDetail){
          state.userDetail = userDetail
        },
        setTechnical(state, technical){
          state.technical = technical
        },
        logout (state, vm) {
            logout();
            // 处理老系统的token
            Cookies.remove('user');
            Cookies.remove('token');
            let envName = process.env.VUE_APP_MIS_ENV;
            if (Cookies.get(envName + '-admin3-token')) {
              Cookies.remove(envName + '-admin3-token', { path: '', domain: '.intramirror.com' });
              Cookies.remove(envName + '-admin3-user', { path: '', domain: '.intramirror.com' });
            }
            // 退出
            MIS.logout();
            gioClearUserId();
            // 恢复默认样式
            let themeLink = document.querySelector('link[name="theme"]');
            themeLink.setAttribute('href', '');
            // 清空打开的页面等数据，但是保存主题数据
            let theme = '';
            if (localStorage.theme) {
                theme = localStorage.theme;
            }
            localStorage.clear();
            if (theme) {
                localStorage.theme = theme;
            }
        }
    }
};

export default user;
